import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import * as vpoActions from '../actions/vpo';
import { RestService } from '../../service/rest.service';
import { dtoFormatter } from '../../shared/helpers/helper.system';
import { VpoName } from '../../models/vpo.model';
import { ServerDTO } from '../../models/app.model';
import { Router } from '@angular/router';


const sliceRoute = (s: string) => s.length > 0 && s.indexOf('/') !== -1 ? s.split('/')[1] : 'gvp';
const getVpoByCode = (vpo: Array<VpoName>, code: string) => vpo.find(_v => _v.code === code);

@Injectable()
export class VpoEffects {

  constructor(
    private actions$: Actions,
    private restService: RestService,
    private router: Router
  ) {}

  @Effect()
  loadVpo$ = this.actions$.pipe(
    ofType<vpoActions.LoadAll>(vpoActions.LOAD_ALL),
    switchMap(() => {
      return this.restService.getVpoActive()
        .pipe(
          map((data: ServerDTO) => {
            const _data = {rows: dtoFormatter<VpoName>(data), selected: null};
            const code = sliceRoute(this.router.url);
            _data.selected = getVpoByCode(_data.rows, code);
            if (!_data.selected) {
              // redirect
              _data.selected = getVpoByCode(_data.rows, 'gvp');
              this.router.navigate(['/gvp']);
            }
            return _data;
          }),
          mergeMap(data => [
            new vpoActions.LoadSuccess(data.rows),
            new vpoActions.UpdateData(data.selected),
            // new messageActions.SuccessMessage(AppMessages.DATA_LOAD_SUCCESS)
          ]),
          catchError(error => [
            new vpoActions.LoadFail(error),
            // new messageActions.ErrorMessage(AppMessages.DATA_LOAD_FAIL)
          ])
        );
    })
  );
}
